import React from 'react'
import Header from '../Header/Header'
import VentasData from '../../Components/Admin/VentasData/VentasData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Ventas() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <VentasData />
                </div>
            </section>
        </div>
    )
}
